import { HttpResponse } from '@angular/common/http';

import { Observable, throwError, timer } from 'rxjs';

export const retryStrategyV2 = (error: HttpResponse<unknown> | string, attempts: number, {
  maxRetryAttempts = 2,
  duration = 500,
  isScalingDuration = true,
  excludedStatusCodes = [400, 401, 403, 404, 422],
}: {
  maxRetryAttempts?: number;
  duration?: number;
  isScalingDuration?: boolean;
  excludedStatusCodes?: number[];
} = {}): Observable<never | 0> => {
  const retryAttempt = attempts + 1;
  // if maximum number of retries have been met
  // or response is a status code we don't wish to retry, throw error
  if (error === 'logout' ||
    (maxRetryAttempts > 0 && retryAttempt > maxRetryAttempts) ||
    excludedStatusCodes.some(e => e === (error as HttpResponse<unknown>).status)
  ) {
    return throwError(() => error);
  }
  // retry after 1s, 2s, etc...
  return timer((isScalingDuration ? retryAttempt : 1) * duration);
};
